import React, { useEffect } from 'react';
import useIsElementInView from 'hooks/useIsElementInView';
import Spinner from 'components/Spinner';
import Box from 'components/Box';
import { jsx as _jsx } from "react/jsx-runtime";
function LoadMoreOnScroll(_ref) {
  var isFetchingNextPage = _ref.isFetchingNextPage,
    hasNextPage = _ref.hasNextPage,
    onFetchNextPage = _ref.onFetchNextPage;
  var _useIsElementInView = useIsElementInView({
      initialValue: false
    }),
    isInView = _useIsElementInView.isInView,
    watchedElementRef = _useIsElementInView.watchedElementRef;
  useEffect(function () {
    if (isInView && hasNextPage) {
      onFetchNextPage({
        cancelRefetch: false
      });
    }
  }, [isInView, hasNextPage, onFetchNextPage]);
  if (!hasNextPage) {
    return null;
  }
  return /*#__PURE__*/_jsx(Box, {
    ref: watchedElementRef,
    mt: "l",
    textAlign: "center",
    children: isFetchingNextPage && /*#__PURE__*/_jsx(Spinner, {
      dimmed: true
    })
  });
}
export default LoadMoreOnScroll;